
import { UserApi,PermissionApi,RefreshApi} from "gmrfid-service-user-api-client"
import {VillageApi} from "gmrfid-service-community-api-client"
import { message } from 'antd';
import { arrayToTree } from '../utils/index';
import defaultSettingsObj from '../defaultSettings';

const { defaultMenu } = defaultSettingsObj;
/* [获取用户信息、获取当前用户按钮权限、获取当前用户的权限] */
const unifiedLogin = (organizeId, history, switchType = false, setTipType, dispatch) => {
  VillageApi.detail({
    id: organizeId,
  }).then((res1) => {
    if (res1.status === 200) {
      Promise.all([
        UserApi.getUserInfo({}),
        PermissionApi.button({}),
        PermissionApi.menu({}),
      ]).then((res) => {
        if (res) {
          sessionStorage.setItem('user', JSON.stringify({ ...res[0].data, organizeId }));
          sessionStorage.setItem('button', JSON.stringify(res[1].data));
          if (switchType) {
            // setTipText('切换成功，请稍后')
            setTipType(false);
          }
          /* 未认证 */
          if (res1.data.verifyState === 'NOT_VERIFIED') {
            setTimeout(() => {
              sessionStorage.setItem('menu', JSON.stringify(defaultMenu));
              history.push(defaultMenu[0].uri);
            }, 1000);
          } else {
            const res2 = arrayToTree(res[2].data, 'id', 'parentId');
            const arr = [];
            res2.map((item) => {
              // if (!item.parentId && item.type !== 'APPLICATION') {
              if (!item.parentId) {
                arr.push(item);
              }
            });
            sessionStorage.setItem('menu', JSON.stringify(arr));
            // /如果有菜单且有子菜单，就子一/
            if (res2.length > 1 && res2[0].children) {
              // history.push(res2[0]?.children[0].uri);
            } else if (res2.length > 0) {
              // history.push(res2 && res2[0].uri);
              history.push('/index');
            } else {
              message.warning('你没有相关权限,联系管理员。');
            }
          }

          /* 重新获取(状态机) */
          if (switchType) {
            dispatch({
              type: 'app/updateStates',
              payload: {
                isRefresh: Math.random(),
              },
            });
          }
        }
      });
    }
  });
};

/* 刷新token */
const refreshFn = (organizeId, history, switchType = false, setTipType, dispatch) => {
  if (switchType) {
    setTipType(true);
  }
  RefreshApi.orgToken({ organizeId }).then((res) => {
    if (res && res.status === 200) {
      sessionStorage.setItem(
        'userInfo',
        JSON.stringify({
          token: res.data,
        }),
      );
      unifiedLogin(organizeId, history, switchType, setTipType, dispatch);
    }
  });
};
export { unifiedLogin, refreshFn };
